import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const StepItem = (props) => {
  const { index, current } = props;
  const stepClasses = classnames({
    ordersteps__item: true,
    'ordersteps__item--current primary': index === current,
    'ordersteps__item--past': index < current,
    'ordersteps__item--next': index > current,
  });
  return (
    <li className={stepClasses}>
      <i className={props.icon} />
      <span>{props.name}</span>
    </li>
  );
};

StepItem.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  current: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};

const OrderSteps = (props) => {
  const steps = [
    { name: 'ORDINA', icon: 'bi_location-pin' },
    { name: 'MENU', icon: 'bi_kitchen-spoon-fork' },
    { name: 'CARRELLO', icon: 'bi_ecommerce-shopcart' },
    { name: 'DATI', icon: 'bi_editorial-pencil-a' },
    { name: 'PAGA', icon: 'bi_ecommerce-cash-a' },
    { name: '', icon: 'bi_com-paperplane' },
  ];
  return (
    <div className="ordersteps">
      <ul>
        {
          steps.map((step, i) => (
            <StepItem
              key={i}
              index={i}
              current={props.current}
              name={step.name}
              icon={step.icon}
            />
          ))
        }
      </ul>
    </div>
  );
};

OrderSteps.propTypes = {
  current: PropTypes.number,
};

export default OrderSteps;



// WEBPACK FOOTER //
// ./src/components/order-steps.js